import { createAction } from "redux-act";

const PRODUCT_IMPORT = "product/data/PRODUCT_IMPORT";
const SET_PRODUCT_IMPORT_TYPE = "product/data/SET_PRODUCT_IMPORT_TYPE";

export const importProduct = createAction(PRODUCT_IMPORT);
export const setProductImportType = createAction(SET_PRODUCT_IMPORT_TYPE, (payload) => payload);
